import {
  Repeat,
  AccountTree,
  Dashboard,
  Assessment,
  Build,
  StorefrontOutlined,
  VerifiedUser,
  PhoneAndroid,
} from '@mui/icons-material';
import type { SvgIconComponent } from '@mui/icons-material';

export interface NavigationItem {
  title: string;
  description: string;
  icon: SvgIconComponent;
  color: string;
  path: string;
}

/** Central config for all dashboard navigation cards */
export const navigationItems: NavigationItem[] = [
  { title: 'Recurring Tasks', description: 'Manage automated ticket templates', icon: Repeat, color: '#ec4899', path: '/recurring-tasks' },
  { title: 'Workflow Automation', description: 'Configure automated workflows', icon: AccountTree, color: '#06b6d4', path: '/workflows' },
  { title: 'Team Management', description: 'Manage teams and assignments', icon: Dashboard, color: '#8b5cf6', path: '/teams/edit' },
  { title: 'Reports', description: 'View reports and analytics', icon: Assessment, color: '#14b8a6', path: '/reports' },
  { title: 'Asset Management', description: 'Manage equipment and PM schedules', icon: Build, color: '#d97706', path: '/assets' },
  { title: 'Vendor Management', description: 'Manage vendors and supplier contacts', icon: StorefrontOutlined, color: '#7c3aed', path: '/vendors' },
  { title: 'Get the Mobile App', description: 'Install Trackly Mobile on your Android device', icon: PhoneAndroid, color: '#3ddc84', path: '/get-the-app' },
];

/** Shown only while the `Compliance` feature flag is on (see NavigationSection). */
export const complianceNavigationItem: NavigationItem = {
  title: 'Compliance Dashboard',
  description: 'Track accreditation and regulatory compliance',
  icon: VerifiedUser,
  color: '#2563eb',
  path: '/compliance',
};
